<swiper-container #swiperContainerElement init="false">
  @for (ad of advertisements(); track ad.id) {
    <swiper-slide class="swiper-slide">
      <a [routerLink]="['/advertisements', ad.id]" class="business">
        <app-advertisement-card [ad]="ad" [categories]="categories()" />
      </a>
    </swiper-slide>
  }
</swiper-container>
<ng-container *transloco="let t">
  <button
    [attr.aria-label]="t('PREVIOUS')"
    class="swiper-navigation-button"
    id="previous-business-button"
    mat-icon-button>
    <mat-icon>navigate_before</mat-icon>
  </button>
  <button [attr.aria-label]="t('NEXT')" class="swiper-navigation-button" id="next-business-button" mat-icon-button>
    <mat-icon>navigate_next</mat-icon>
  </button>
</ng-container>
